import { AutocompleteItem } from '../../../../shared/AutocompleteTextInput';
import { SelectOptions } from '../../../../shared/form/inputs/Select';

const roomTypesConstants: Array<string> = [
  'Bathroom',
  'Bedroom',
  'Conservatory',
  'Hall/Landing',
  'Kitchen',
  'Dining/Living/Lounge/Sitting',
  'Utility',
  'WC',
];

export type RoomType = typeof roomTypesConstants[number];

export const roomTypeSelectOptions: SelectOptions<RoomType> = roomTypesConstants.map(roomType => ({
  value: roomType,
  text: roomType,
}));

export const roomTypeTemperatureRecord: Record<RoomType, number> = {
  Bathroom: 22,
  Bedroom: 18,
  Conservatory: 21,
  'Hall/Landing': 19,
  Kitchen: 18,
  'Dining/Living/Lounge/Sitting': 21,
  Utility: 19,
  WC: 19,
};

export type RoomAutocompleteItem = {
  roomType: RoomType;
} & AutocompleteItem;

export const getRoomTypeOrNull = (roomName: string): RoomType | null => {
  const match = roomTypes.filter(roomType => roomType.displayText === roomName)[0];
  return match == null ? null : match.roomType;
};

export const roomTypes: Array<RoomAutocompleteItem> = [
  { id: '1', displayText: 'Annex bathroom', roomType: 'Bathroom' },
  { id: '2', displayText: 'Annex ensuite', roomType: 'Bathroom' },
  { id: '3', displayText: 'Annex shower', roomType: 'Bathroom' },
  { id: '4', displayText: 'Bathroom', roomType: 'Bathroom' },
  { id: '5', displayText: 'Bathroom 1', roomType: 'Bathroom' },
  { id: '6', displayText: 'Bathroom 2', roomType: 'Bathroom' },
  { id: '7', displayText: 'Bathroom 3', roomType: 'Bathroom' },
  { id: '8', displayText: 'Changing room', roomType: 'Bathroom' },
  { id: '9', displayText: 'Changing/shower room', roomType: 'Bathroom' },
  { id: '10', displayText: 'Ensuite', roomType: 'Bathroom' },
  { id: '11', displayText: 'Ensuite 1', roomType: 'Bathroom' },
  { id: '12', displayText: 'Ensuite 2', roomType: 'Bathroom' },
  { id: '13', displayText: 'Ensuite 3', roomType: 'Bathroom' },
  { id: '14', displayText: 'Ensuite 4', roomType: 'Bathroom' },
  { id: '15', displayText: 'Ensuite 5', roomType: 'Bathroom' },
  { id: '16', displayText: 'Ensuite 6', roomType: 'Bathroom' },
  { id: '17', displayText: 'Ensuite 7', roomType: 'Bathroom' },
  { id: '18', displayText: 'Ensuite/dressing room', roomType: 'Bathroom' },
  { id: '19', displayText: 'Family bathroom', roomType: 'Bathroom' },
  { id: '20', displayText: 'Guest ensuite', roomType: 'Bathroom' },
  { id: '21', displayText: 'Her ensuite', roomType: 'Bathroom' },
  { id: '22', displayText: 'His ensuite', roomType: 'Bathroom' },
  { id: '23', displayText: 'Master ensuite', roomType: 'Bathroom' },
  { id: '24', displayText: 'Master ensuite/dressing', roomType: 'Bathroom' },
  { id: '25', displayText: 'Sauna', roomType: 'Bathroom' },
  { id: '26', displayText: 'Shared ensuite', roomType: 'Bathroom' },
  { id: '27', displayText: 'Shower room', roomType: 'Bathroom' },
  { id: '28', displayText: 'Shower/boot room', roomType: 'Bathroom' },
  { id: '29', displayText: 'Shower/utility', roomType: 'Bathroom' },
  { id: '30', displayText: 'Spa', roomType: 'Bathroom' },
  { id: '31', displayText: 'Spa', roomType: 'Bathroom' },
  { id: '32', displayText: 'Steam room', roomType: 'Bathroom' },
  { id: '33', displayText: 'Utility/shower', roomType: 'Bathroom' },
  { id: '34', displayText: 'Washroom', roomType: 'Bathroom' },
  { id: '35', displayText: 'Wet room', roomType: 'Bathroom' },
  { id: '36', displayText: 'Annex bedroom', roomType: 'Bedroom' },
  { id: '37', displayText: 'Attic bedroom', roomType: 'Bedroom' },
  { id: '38', displayText: 'Bedroom', roomType: 'Bedroom' },
  { id: '39', displayText: 'Bedroom 1', roomType: 'Bedroom' },
  { id: '40', displayText: 'Bedroom 2', roomType: 'Bedroom' },
  { id: '41', displayText: 'Bedroom 3', roomType: 'Bedroom' },
  { id: '42', displayText: 'Bedroom 4', roomType: 'Bedroom' },
  { id: '43', displayText: 'Bedroom 5', roomType: 'Bedroom' },
  { id: '44', displayText: 'Bedroom 6', roomType: 'Bedroom' },
  { id: '45', displayText: 'Bedroom 7', roomType: 'Bedroom' },
  { id: '46', displayText: 'Box room', roomType: 'Bedroom' },
  { id: '47', displayText: 'Guest bedroom', roomType: 'Bedroom' },
  { id: '48', displayText: 'Master bedroom', roomType: 'Bedroom' },
  { id: '49', displayText: `Nanny's bedroom`, roomType: 'Bedroom' },
  { id: '50', displayText: 'Nursery', roomType: 'Bedroom' },
  { id: '51', displayText: 'Principal bedroom', roomType: 'Bedroom' },
  { id: '52', displayText: 'Spare bedroom', roomType: 'Bedroom' },
  { id: '53', displayText: 'Staff bedroom', roomType: 'Bedroom' },
  { id: '54', displayText: 'Conservatory', roomType: 'Conservatory' },
  { id: '55', displayText: 'Garden room', roomType: 'Conservatory' },
  { id: '56', displayText: 'Orangery', roomType: 'Conservatory' },
  { id: '57', displayText: 'Sun lounge', roomType: 'Conservatory' },
  { id: '58', displayText: 'Sun room', roomType: 'Conservatory' },
  { id: '59', displayText: 'Annex living', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '60', displayText: 'Annex living/kitchen', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '61', displayText: 'Attic', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '62', displayText: 'Bar', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '63', displayText: 'Bedroom/study', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '64', displayText: 'Bonus room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '65', displayText: 'Breakfast room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '66', displayText: `Carer's Room`, roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '67', displayText: 'Cinema room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '68', displayText: 'Classroom', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '69', displayText: 'Day room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '70', displayText: 'Den', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '71', displayText: 'Dining hall', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '72', displayText: 'Dining room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '73', displayText: 'Drawing room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '74', displayText: 'Dressing room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '75', displayText: 'Entertainment room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '76', displayText: 'Extension', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '77', displayText: 'Family room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '78', displayText: 'Family/dining room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '79', displayText: 'Farm office', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '80', displayText: 'Flexible room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '81', displayText: 'Formal Dining room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '82', displayText: 'Formal Living room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '83', displayText: 'Formal lounge', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '84', displayText: 'Front room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '85', displayText: 'Function room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '86', displayText: 'Future extension', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '87', displayText: 'Games room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '88', displayText: 'Grand hall', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '89', displayText: 'Guest living', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '90', displayText: 'Guest suite', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '91', displayText: 'Gymnasium', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '92', displayText: 'Her dressing room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '93', displayText: 'His dressing room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '94', displayText: 'Hobby/craft room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '95', displayText: 'Home office', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '96', displayText: 'Kitchen/breakfast room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '97', displayText: 'Kitchen/breakfast/dining room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '98', displayText: 'Kitchen/dining room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '99', displayText: 'Kitchen/dining/family room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '100', displayText: 'Kitchen/dining/living room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '101', displayText: 'Kitchen/dining/lounge', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '102', displayText: 'Kitchen/dining/sitting room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '103', displayText: 'Kitchen/family room  ', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '104', displayText: 'Kitchen/living room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '105', displayText: 'Kitchen/lounge', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '106', displayText: 'Library', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '107', displayText: 'Living room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '108', displayText: 'Living room/kitchen', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '109', displayText: 'Living/dining room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '110', displayText: 'Lounge', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '111', displayText: 'Man Cave', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '112', displayText: 'Master dressing room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '113', displayText: 'Master suite', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '114', displayText: 'Master suite', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '115', displayText: 'Media Room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '116', displayText: 'Meeting room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '117', displayText: 'Mezzanine', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '118', displayText: 'Morning room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '119', displayText: 'Multi purpose space', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '120', displayText: 'Music room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '121', displayText: 'Office', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '122', displayText: 'Parlour', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '123', displayText: 'Playroom', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '124', displayText: 'Powder room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '125', displayText: 'Prayer room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '126', displayText: 'Reception', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '127', displayText: 'Recreation room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '128', displayText: 'Room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '129', displayText: 'Sewing room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '130', displayText: 'Sitting room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '131', displayText: 'Snooker room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '132', displayText: 'Snug', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '133', displayText: 'Staff room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '134', displayText: 'Staff suite', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '135', displayText: 'Studio', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '136', displayText: 'Study', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '137', displayText: 'Study/bedroom', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '138', displayText: 'Study/landing', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '139', displayText: 'Therapy room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '140', displayText: 'Treatment room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '141', displayText: 'TV room', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '142', displayText: 'Walk-in wardrobe', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '143', displayText: 'Wardrobe', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '144', displayText: 'Workroom', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '145', displayText: 'Zone', roomType: 'Dining/Living/Lounge/Sitting' },
  { id: '146', displayText: 'Annex hall', roomType: 'Hall/Landing' },
  { id: '147', displayText: 'Basement hall', roomType: 'Hall/Landing' },
  { id: '148', displayText: 'Basement lobby', roomType: 'Hall/Landing' },
  { id: '149', displayText: 'Circulation', roomType: 'Hall/Landing' },
  { id: '150', displayText: 'Coats', roomType: 'Hall/Landing' },
  { id: '151', displayText: 'Corridor', roomType: 'Hall/Landing' },
  { id: '152', displayText: 'Cupboard', roomType: 'Hall/Landing' },
  { id: '153', displayText: 'Entrance hall', roomType: 'Hall/Landing' },
  { id: '154', displayText: 'Entrance lobby', roomType: 'Hall/Landing' },
  { id: '155', displayText: 'Entrance porch', roomType: 'Hall/Landing' },
  { id: '156', displayText: 'Foyer', roomType: 'Hall/Landing' },
  { id: '157', displayText: 'Gallery', roomType: 'Hall/Landing' },
  { id: '158', displayText: 'Gallery landing', roomType: 'Hall/Landing' },
  { id: '159', displayText: 'Glazed Link', roomType: 'Hall/Landing' },
  { id: '160', displayText: 'Hall', roomType: 'Hall/Landing' },
  { id: '161', displayText: 'Inner hall', roomType: 'Hall/Landing' },
  { id: '162', displayText: 'Inner lobby', roomType: 'Hall/Landing' },
  { id: '163', displayText: 'Landing', roomType: 'Hall/Landing' },
  { id: '164', displayText: 'Linen', roomType: 'Hall/Landing' },
  { id: '165', displayText: 'Link  ', roomType: 'Hall/Landing' },
  { id: '166', displayText: 'Lobby', roomType: 'Hall/Landing' },
  { id: '167', displayText: 'Lower hall', roomType: 'Hall/Landing' },
  { id: '168', displayText: 'Lower landing', roomType: 'Hall/Landing' },
  { id: '169', displayText: 'Main hall', roomType: 'Hall/Landing' },
  { id: '170', displayText: 'Passage', roomType: 'Hall/Landing' },
  { id: '171', displayText: 'Porch', roomType: 'Hall/Landing' },
  { id: '172', displayText: 'Rear hall', roomType: 'Hall/Landing' },
  { id: '173', displayText: 'Rear lobby', roomType: 'Hall/Landing' },
  { id: '174', displayText: 'Reception hall', roomType: 'Hall/Landing' },
  { id: '175', displayText: 'Side hall', roomType: 'Hall/Landing' },
  { id: '176', displayText: 'Stair hall', roomType: 'Hall/Landing' },
  { id: '177', displayText: 'Store', roomType: 'Hall/Landing' },
  { id: '178', displayText: 'Upper landing', roomType: 'Hall/Landing' },
  { id: '179', displayText: 'Vestibule', roomType: 'Hall/Landing' },
  { id: '180', displayText: 'Annex kitchen', roomType: 'Kitchen' },
  { id: '181', displayText: 'Existing kitchen', roomType: 'Kitchen' },
  { id: '182', displayText: 'Kitchen', roomType: 'Kitchen' },
  { id: '183', displayText: 'Kitchenette', roomType: 'Kitchen' },
  { id: '184', displayText: 'Pantry', roomType: 'Kitchen' },
  { id: '185', displayText: 'Prep kitchen', roomType: 'Kitchen' },
  { id: '186', displayText: 'Scullery', roomType: 'Kitchen' },
  { id: '187', displayText: 'Servery ', roomType: 'Kitchen' },
  { id: '188', displayText: 'Spice Kitchen', roomType: 'Kitchen' },
  { id: '189', displayText: 'Boiler room', roomType: 'Utility' },
  { id: '190', displayText: 'Boot room', roomType: 'Utility' },
  { id: '191', displayText: 'Cellar', roomType: 'Utility' },
  { id: '192', displayText: 'Dog room', roomType: 'Utility' },
  { id: '193', displayText: 'Drying room', roomType: 'Utility' },
  { id: '194', displayText: 'Garage', roomType: 'Utility' },
  { id: '195', displayText: 'Garage/Workshop', roomType: 'Utility' },
  { id: '196', displayText: 'Laundry', roomType: 'Utility' },
  { id: '197', displayText: 'Plant', roomType: 'Utility' },
  { id: '198', displayText: 'Pool surround  ', roomType: 'Utility' },
  { id: '199', displayText: 'Utility', roomType: 'Utility' },
  { id: '200', displayText: 'Utility/boot room', roomType: 'Utility' },
  { id: '201', displayText: 'Utility/WC', roomType: 'Utility' },
  { id: '202', displayText: 'Workshop', roomType: 'Utility' },
  { id: '203', displayText: 'Cloaks', roomType: 'WC' },
  { id: '204', displayText: `Gent's WCs`, roomType: 'WC' },
  { id: '205', displayText: `Ladies' WCs`, roomType: 'WC' },
  { id: '206', displayText: 'WC', roomType: 'WC' },
  { id: '207', displayText: 'WC/Cloaks', roomType: 'WC' },
];
